import type { ServiceCategory } from './types';

/**
 * LEGACY CATEGORY SPELLINGS. This is the only place the console would know about one.
 *
 * `service-categories@v2` (providers-by-service M2) split `flight-data`, which mixed
 * flight information with seats to buy, into `flight-info`, `passenger-data` and
 * `air-ticketing`, and kept the old name as an alias of `air-ticketing`. Slice P4
 * (`service-categories@v3`, M3) removed it from the contract's union: since R4 no
 * declarant sends it, and the control plane serves every row and routing key under
 * its service. The console no longer reads `flight-data` at all; a row that still
 * carried it would show as a category of its own, never silently as air tickets.
 *
 * The rest of the console reads a category only through {@link canonicalCategory},
 * and the wire union `IntegrationCategory` (`types.ts`) takes any legacy member from
 * this map. Today the map is empty: `LegacyIntegrationCategory` is `never` and
 * `canonicalCategory` is the identity.
 */
export const LEGACY_CATEGORY_ALIASES = {} as const satisfies Readonly<Record<string, ServiceCategory>>;

/** A spelling the contract still accepts from a declarant that is no longer a service of its own. */
export type LegacyIntegrationCategory = keyof typeof LEGACY_CATEGORY_ALIASES;

const ALIASES: Readonly<Partial<Record<string, ServiceCategory>>> = LEGACY_CATEGORY_ALIASES;

/** The service a category is read as: the one its legacy spelling stands for, or itself. */
export function canonicalCategory(category: string): string {
  return ALIASES[category] ?? category;
}
